export default __webpack_public_path__ + "static/media/error.bfbf7d3a.jpg";